module.exports = __webpack_public_path__ + "static/media/rahma.5e6f7993.png";